import Button from '@mui/material/Button';
import CircularProgress from '@mui/material/CircularProgress';
import DownloadIcon from '@mui/icons-material/Download';
import { useActivityExport } from '../hooks/useActivityExport';

export default function ActivityExport() {
  const { exportActivity, isPending } = useActivityExport();

  return (
    <div data-testid="activity-export">
      <Button
        variant="outlined"
        size="small"
        startIcon={isPending ? <CircularProgress size={16} /> : <DownloadIcon />}
        onClick={() => void exportActivity()}
        disabled={isPending}
        sx={{ textTransform: 'none' }}
      >
        {isPending ? 'Exporting…' : 'Export JSON'}
      </Button>
    </div>
  );
}
